<script>
import EventBus from "@/utils/EventBus";

const MENU_OPTIONS_MAP = {
  "ai_chat": "AI Chat",
  "website": "Website",
  "reviews": "Reviews",
  "webmd": "WebMD",
  "text_to_pay": "Text To Pay",
  "ai_dialer": "AI Auto Dialer",
  "appointments": "Appointments"
}

export default {
  name: "ProductsAppBar",
  props: {
    products: {
      type: Array,
      required: true
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    app: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    isMobile: false
  }),
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  methods: {
    getLogo() {
      const {isDark} = this.$vuetify.theme;
      return isDark ? '/logow.svg' : '/logo.svg';
    },
    formatMenuName(menu) {
      if (menu in MENU_OPTIONS_MAP) {
        return MENU_OPTIONS_MAP[menu];
      }
      return menu.replace(/_/g, " ").toUpperCase();
    },
    menuOptionClick(option) {
      EventBus.$emit("products-app-bar-clicked", this.products[option], option)
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    }
  }
}
</script>

<template>
  <v-app-bar
    :app="app"
    color="dddark"
    scroll-off-screen
  >
    <img
      v-if="showLogo"
      class="d-block"
      :src="getLogo()"
      :width="150"
      :height="30"/>

    <template v-if="isMobile" v-slot:extension>
      <v-tabs align-with-title left center-active @change="menuOptionClick" class="tabs-container">
        <v-tab v-for="(menu) in products" :key="menu">{{ formatMenuName(menu) }}</v-tab>
      </v-tabs>
    </template>
    <v-tabs v-if="!isMobile" align-with-title left center-active @change="menuOptionClick" class="tabs-container">
      <v-tab v-for="(menu) in products" :key="menu">{{ formatMenuName(menu) }}</v-tab>
    </v-tabs>
  </v-app-bar>
</template>

<style scoped>

.tabs-container {
  flex: 1;
}
</style>